import { useMutation, useQueryClient } from '@tanstack/react-query';

import { updateReward } from '~/services/AgentHub/AgentService';

import { Reward, UpdateRewardParams } from '~/types/services/agentHub';

import { rewardQueryKeys } from './useListRewards';

interface UpdateRewardVariables {
  rewardId: string;
  data: UpdateRewardParams;
}

interface UseUpdateRewardOptions {
  onSuccess?: (data: Reward) => void;
  onError?: (error: Error) => void;
}

export function useUpdateReward(options: UseUpdateRewardOptions = {}) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ rewardId, data }: UpdateRewardVariables) => {
      return await updateReward(rewardId, data);
    },
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: rewardQueryKeys.all });
      options.onSuccess?.(data);
    },
    onError: (error: Error) => {
      options.onError?.(error);
    },
  });
}
